import React, { useEffect, useState } from "react";
import { Button, Table, Tooltip, Tag, Spin, Flex, Popconfirm } from "antd";
import { IoMdAdd } from "react-icons/io";
//@ts-ignore
import cloud from "../../assets/cloud.png";
import CreateNotifications from "../Modals/createNotifications/CreateNotifications";
import "../../styles/pages/recentAnnouncement/index.css"; // Ensure your custom styles are imported correctly
import {
  deleteAnnoucenment,
  getAllAnnouncements,
} from "../../store/services/announcement";
import { useAppSelector } from "../../store/hooks";
import CustomPagination from "../Pagination/CustomPagination";
import GHeader from "../GeneralHeader/GHeader";
import { RiDeleteBin6Line } from "react-icons/ri";

interface User {
  id: number;
  firstName: string;
  lastName: string;
}

const RecentAnnouncement: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingId, setLoadingId] = useState("");
  const { announceData, count, loading } = useAppSelector(
    (state) => state.announcement
  );

  const showModal = () => {
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "22%",
      render: (text: any) => {
        return (
          <div className="table_data_text">
            <p>{text.charAt(0).toUpperCase() + text.slice(1)}</p>
          </div>
        );
      },
    },
    {
      title: "Notification Type",
      dataIndex: "notificationType",
      key: "notificationType",
      width: "20%",
      render: (text: any) => {
        return (
          <div className="table_data_text">
            <p>{text.charAt(0).toUpperCase() + text.slice(1)}</p>
          </div>
        );
      },
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      width: "20%",
      render: (text: any) => {
        return (
          <div className="table_data_text">
            <p>{text.charAt(0).toUpperCase() + text.slice(1)}</p>
          </div>
        );
      },
    },
    {
      title: "Users",
      dataIndex: "users",
      key: "users",
      width: "22%",
      render: (users: User[], record: any) => {
        if (record?.notificationType === "general") {
          return <Tag className="table_users_tag">All</Tag>;
        }
        if (!users || users.length === 0) {
          return <Tag className="table_users_tag">0</Tag>;
        }
        return (
          <Tooltip
            title={
              <div>
                {users.map((item, index) => (
                  <Tag key={index} className="table_users_tooltip_tag">
                    {item.firstName} {item.lastName}
                  </Tag>
                ))}
              </div>
            }
            overlayInnerStyle={{ backgroundColor: "#F7F7F7", border: "none" }}
          >
            <Tag className="table_users_tag">{users.length}</Tag>
          </Tooltip>
        );
      },
    },
    {
      title: " Action",
      dataIndex: "actions",
      key: "actions",
      width: "10%",
      render: (_: any, record: any) => {
        return (
          <div className="table_actions">
            {loadingId === record.id ? (
              <Spin />
            ) : (
              <Popconfirm
                title="Archive Level"
                description="Are you sure add to archive ?"
                onConfirm={(e) => {
                  e?.stopPropagation();
                }}
                okText="Yes"
                cancelText="No"
              >
                <RiDeleteBin6Line
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteAnnouncement(record);
                  }}
                />
              </Popconfirm>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getAllAnnouncements({ perPage: 8, page: currentPage });
  }, [currentPage]);

  const handleDeleteAnnouncement = async (record: any) => {
    if (!record?.id) return;
    setLoadingId(record.id);
    const res = await deleteAnnoucenment(record.id);
    if (res) {
      getAllAnnouncements({ perPage: 8, page: currentPage });
    }
    setLoadingId("");
  };

  return (
    <>
      <CreateNotifications
        isModalOpen={isModalOpen}
        currentPage={currentPage}
        setIsModalOpen={setIsModalOpen}
      />
      <div className="main_parent responsive">
        <GHeader
          heading="Announcements"
          buttonText="Create Announcement"
          onClick={showModal}
        />
        <div className="mian_tab">
          {loading ? (
            <Flex
              align="center"
              style={{ height: "50vh" }}
              justify="center"
              gap="middle"
            >
              <Spin size="large" />
            </Flex>
          ) : (
            <>
              {announceData.length > 0 ? (
                <div>
                  <div className="table_container">
                    <Table
                      className="custom_table_design"
                      dataSource={announceData}
                      columns={columns}
                      pagination={false}
                      scroll={{ x: 600 }}
                    />
                  </div>
                </div>
              ) : (
                <div className="noAnnouncmentContainer">
                  <div>
                    <div>
                      <img width={"110px"} src={cloud} alt="cloud" />
                    </div>
                    <div>
                      <h2>You have no announcement here</h2>
                      <p>Create a first announcement</p>
                    </div>
                    {announceData.length > 0 && (
                      <Button
                        className=""
                        style={{ width: "360px" }}
                        icon={<IoMdAdd className="mark-read" />}
                        onClick={showModal}
                      >
                        Create Announcement
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {announceData?.length > 0 && (
          <div className="main_pagination">
            <CustomPagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              total={count}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RecentAnnouncement;
